import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classes from './EmptyDash.module.css';
const checkEmpty = (val) => {
    return val === null || val === undefined || (typeof val === 'string' && val.trim() === '');
};
export const EmptyDash = ({ children }) => {
    if ((Array.isArray(children) && children.length === 0) ||
        (Array.isArray(children) && children.every(checkEmpty)) ||
        checkEmpty(children)) {
        return _jsx("span", { className: classes.dash, children: "\u2013" });
    }
    return _jsx(_Fragment, { children: children });
};
